import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import StripeElementWrapper from 'components/shared/StripeElementWrapper';
import stripeImg from 'assets/img/stripe.png';
import { Grid, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  stripe: {
    filter: 'grayscale(1)',
    opacity: 0.5,
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(3),
  },
});

const CreditCardForm = ({
  classes,
}) => (
  <>
    <img
      alt="Stripe"
      src={stripeImg}
      className={classes.stripe}
      style={{ width: 60 }}
    />
    <Grid
      container
      spacing={2}
      alignItems="center"
    >
      <Grid
        item
        xs={12}
      >
        <StripeElementWrapper
          label={(
            <FormattedMessage
              id="Card Number"
              defaultMessage="Card Number"
            />
          )}
          labelWidth={100}
          component={CardNumberElement}
          placeholder="0000 0000 0000 0000"
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <StripeElementWrapper
          label={(
            <FormattedMessage
              id="Expiry"
              defaultMessage="Expiry"
            />
          )}
          labelWidth={65}
          component={CardExpiryElement}
          placeholder="MM / YY"
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <StripeElementWrapper
          label={(
            <FormattedMessage
              id="CVC"
              defaultMessage="CVC"
            />
          )}
          labelWidth={45}
          component={CardCVCElement}
          placeholder="xxx"
        />
      </Grid>
    </Grid>
  </>
);

CreditCardForm.propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

export default injectStripe(withStyles(styles)(CreditCardForm));
